/**
 * 认一张图的真实格式，以及它是静图还是动图。
 * 文件名只给人看。格式看文件头，静动看内容：gif 数帧，webp 看动画块，png 看 acTL，jpg 没有动画帧。
 */

export function classifyImageBytes(bytes) {
  if (!bytes || bytes.length < 3) {
    return null
  }
  if (isPng(bytes)) {
    return { animated: pngFrameCount(bytes) >= 2 }
  }
  if (isJpeg(bytes)) {
    return { animated: false }
  }
  if (isGif(bytes)) {
    return { animated: gifImageCount(bytes) >= 2 }
  }
  if (isWebp(bytes)) {
    return { animated: webpAnimated(bytes) }
  }
  return null
}

function isPng(bytes) {
  return bytes.length >= 8
    && bytes[0] === 0x89
    && bytes[1] === 0x50
    && bytes[2] === 0x4e
    && bytes[3] === 0x47
    && bytes[4] === 0x0d
    && bytes[5] === 0x0a
    && bytes[6] === 0x1a
    && bytes[7] === 0x0a
}

function isJpeg(bytes) {
  return bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff
}

function isGif(bytes) {
  return bytes.length >= 6
    && bytes[0] === 0x47
    && bytes[1] === 0x49
    && bytes[2] === 0x46
    && bytes[3] === 0x38
    && (bytes[4] === 0x37 || bytes[4] === 0x39)
    && bytes[5] === 0x61
}

function isWebp(bytes) {
  return bytes.length >= 12
    && ascii(bytes, 0, 4) === 'RIFF'
    && ascii(bytes, 8, 4) === 'WEBP'
}

function pngFrameCount(bytes) {
  let offset = 8
  while (offset + 8 <= bytes.length) {
    const length = u32be(bytes, offset)
    const type = ascii(bytes, offset + 4, 4)
    if (length < 0 || offset + 12 + length > bytes.length) {
      break
    }
    if (type === 'acTL' && length >= 4) {
      return u32be(bytes, offset + 8)
    }
    if (type === 'IEND') {
      break
    }
    offset += 12 + length
  }
  return 1
}

function gifImageCount(bytes) {
  if (bytes.length < 13) {
    return 0
  }
  let offset = 13
  const packed = bytes[10]
  if (packed & 0x80) {
    offset += 3 * (1 << ((packed & 7) + 1))
  }
  let images = 0
  while (offset < bytes.length) {
    const marker = bytes[offset]
    if (marker === 0x3b) {
      break
    }
    if (marker === 0x21) {
      offset += 2
      offset = skipSubBlocks(bytes, offset)
      continue
    }
    if (marker === 0x2c) {
      images += 1
      if (offset + 10 > bytes.length) {
        break
      }
      const localPacked = bytes[offset + 9]
      offset += 10
      if (localPacked & 0x80) {
        offset += 3 * (1 << ((localPacked & 7) + 1))
      }
      offset += 1
      offset = skipSubBlocks(bytes, offset)
      continue
    }
    break
  }
  return images
}

function webpAnimated(bytes) {
  let offset = 12
  while (offset + 8 <= bytes.length) {
    const type = ascii(bytes, offset, 4)
    const size = u32le(bytes, offset + 4)
    if (size < 0 || offset + 8 + size > bytes.length) {
      break
    }
    if (type === 'ANIM') {
      return true
    }
    if (type === 'VP8X' && size >= 1 && (bytes[offset + 8] & 0x02) !== 0) {
      return true
    }
    offset += 8 + size + (size & 1)
  }
  return false
}

function skipSubBlocks(bytes, offset) {
  while (offset < bytes.length) {
    const size = bytes[offset]
    offset += 1
    if (size === 0) {
      return offset
    }
    offset += size
  }
  return offset
}

function ascii(bytes, offset, length) {
  let text = ''
  for (let index = 0; index < length; index += 1) {
    text += String.fromCharCode(bytes[offset + index])
  }
  return text
}

function u32be(bytes, offset) {
  if (offset + 4 > bytes.length) {
    return -1
  }
  return ((bytes[offset] << 24) | (bytes[offset + 1] << 16) | (bytes[offset + 2] << 8) | bytes[offset + 3]) >>> 0
}

function u32le(bytes, offset) {
  if (offset + 4 > bytes.length) {
    return -1
  }
  return (bytes[offset] | (bytes[offset + 1] << 8) | (bytes[offset + 2] << 16) | (bytes[offset + 3] << 24)) >>> 0
}
